import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { createMissionInfo, updateMissionInfo } from '@/api/missionInfo';
import { ElInputTag } from 'el-input-tag';
import vueJsonEditor from 'vue-json-editor';
import validator from 'validator';
import ImageUpload from './ImageUpload.vue';
import { handArmFunctions, missionTypes, NOT_SET_NUMBER } from '@/utils/constants';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "missionInfo", void 0);
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "action", void 0);
    _defineProperty(_this, "showImageUpload", false);
    _defineProperty(_this, "formRules", {
      type: [{
        required: true,
        message: 'type is required',
        trigger: 'change'
      }],
      title: [{
        required: true,
        message: 'title is required',
        trigger: 'blur'
      }],
      image: [{
        validator: _this.validateImage,
        trigger: 'blur'
      }],
      linkString: [{
        validator: _this.validateLinks,
        trigger: 'blur'
      }],
      description: [{
        required: true,
        message: 'description is required',
        trigger: 'blur'
      }]
    });
    _defineProperty(_this, "missionTypes", missionTypes);
    _defineProperty(_this, "handArmFunctions", handArmFunctions);
    _defineProperty(_this, "formData", Object.assign({
      linkString: ''
    }, _this.missionInfo));
    _defineProperty(_this, "meta", '');
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {}
  }, {
    key: "onMetaChange",
    value: function onMetaChange(value) {
      this.formData.meta = JSON.stringify(value);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var form = this.$refs['dataForm'];
      if (form) form.resetFields();
      var formData = Object.assign({
        linkString: ''
      }, this.missionInfo);
      if (formData.day === NOT_SET_NUMBER) {
        formData.day = null;
      }
      if (!formData.meta) {
        this.meta = '';
      } else {
        this.meta = JSON.parse(formData.meta);
      }
      if (formData.links) {
        formData.linkString = formData.links.join('\r\n');
      }
      this.formData = formData;
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.$emit('update:visible', false);
    }
  }, {
    key: "initReqData",
    value: function initReqData() {
      var reqData = Object.assign({}, this.formData);
      reqData.links = reqData.linkString.split(/\r?\n/);
      delete reqData.linkString;
      return reqData;
    }
  }, {
    key: "validateImage",
    value: function validateImage(rule, image, callback) {
      if (validator.isEmpty(image)) {
        callback();
        return;
      }
      if (image.startsWith('data:image/') || validator.isURL(image)) {
        callback();
      } else {
        callback(new Error('Image is not valid'));
      }
    }
  }, {
    key: "validateLinks",
    value: function validateLinks(rule, linkString, callback) {
      if (this.formData.type === 'QUIZ' || this.formData.type === 'READING' || this.formData.type === 'ACTIVITY') {
        this.formData.linkString = '';
        callback();
        return;
      }
      if (validator.isEmpty(linkString)) {
        callback();
        return;
      }
      var links = linkString.split(/\r?\n/);
      var isValid = true;
      links.some(function (link) {
        if (validator.isEmpty(link) || !validator.isURL(link)) {
          isValid = false;
          return true;
        }
      });
      if (isValid) callback();else callback(new Error('URL is not valid'));
    }
  }, {
    key: "createData",
    value: function createData() {
      var _this2 = this;
      this.$refs['dataForm'].validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var data;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return createMissionInfo(_this2.initReqData());
              case 1:
                data = _context.v;
                _this2.$notify({
                  title: 'Created',
                  message: 'Created Successfully',
                  type: 'success',
                  duration: 2000
                });
                _this2.handleClose();
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "updateData",
    value: function updateData() {
      var _this3 = this;
      this.$refs['dataForm'].validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var data;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!valid) {
                  _context2.n = 2;
                  break;
                }
                _context2.n = 1;
                return updateMissionInfo(_this3.initReqData());
              case 1:
                data = _context2.v;
                _this3.$notify({
                  title: 'Updated',
                  message: 'Updated Successfully',
                  type: 'success',
                  duration: 2000
                });
                _this3.handleClose();
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "showUploadImage",
    value: function showUploadImage() {
      this.showImageUpload = !this.showImageUpload;
    }
  }, {
    key: "onSrcFileSet",
    value: function onSrcFileSet(jsonData, field) {}
  }, {
    key: "onCropSuccess",
    value: function onCropSuccess(imgDataUrl, field) {
      this.formData.image = imgDataUrl;
      this.showImageUpload = false;
    }
  }, {
    key: "onCropUploadSuccess",
    value: function onCropUploadSuccess(jsonData, field) {
      this.showImageUpload = false;
    }
  }, {
    key: "onCropUploadFail",
    value: function onCropUploadFail(status, field) {}
  }, {
    key: "onCloseImageUpload",
    value: function onCloseImageUpload() {
      this.showImageUpload = false;
    }
  }]);
}(Vue);
__decorate([Prop({
  required: false
})], default_1.prototype, "missionInfo", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "title", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "visible", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "action", void 0);
default_1 = __decorate([Component({
  name: 'EditorMission',
  components: {
    ImageUpload: ImageUpload,
    ElInputTag: ElInputTag,
    vueJsonEditor: vueJsonEditor
  }
})], default_1);
export default default_1;